import { isValid, parseISO } from 'date-fns';
import { format, utcToZonedTime } from 'date-fns-tz';

export const FORMAT_DAY_DATE_MONTH_YEAR = 'EEE, d MMM yyyy';

export const formatDayDateMonthYear = (date) =>
  date && isValid(date) ? format(date, FORMAT_DAY_DATE_MONTH_YEAR) : '';

export const FORMAT_YEAR_MONTH_DATE = 'yyyy-MM-dd';

export const formatYearMonthDate = (date) =>
  date && isValid(date) ? format(date, FORMAT_YEAR_MONTH_DATE) : '';

export const FORMAT_DATE_MONTH_YEAR = 'd MMM yyyy';

export const formatDateMonthYear = (date) =>
  date && isValid(date) ? format(date, FORMAT_DATE_MONTH_YEAR) : '';

export const FORMAT_YEAR_MONTH_DATE_HOUR_MINUTE_SECOND = 'yyyy-MM-dd HH:mm:ss';

export const FORMAT_DATE_MONTH_YEAR_HOUR_MINUTE = 'd MMM yyyy HH:mm';
export const FORMAT_YEAR_MONTH_DATE_HOUR_MINUTE = 'yyyy-MM-dd HH:mm';

export const formatDateMonthYearHourMinute = (date) =>
  date && isValid(date) ? format(date, FORMAT_DATE_MONTH_YEAR_HOUR_MINUTE) : '';

export const formatYearMonthDateHourMinute = (date) =>
  date && isValid(date) ? format(date, FORMAT_YEAR_MONTH_DATE_HOUR_MINUTE) : '';

export const formatYearMonthDateHoursSeconds = (date) =>
  date && isValid(date) ? format(date, FORMAT_YEAR_MONTH_DATE_HOUR_MINUTE_SECOND) : '';

export const FORMAT_DAY_DATE_MONTH_YEAR_NO_COMMA = 'iii d MMM yyyy';

export const formatDayDateMonthYearNoComma = (date) =>
  date && isValid(date) ? format(date, FORMAT_DAY_DATE_MONTH_YEAR_NO_COMMA) : '';

export const FORMAT_MONTH_YEAR = 'MMM yyyy';

export const formatMonthYear = (date) =>
  date && isValid(date) ? format(date, FORMAT_MONTH_YEAR) : '';

export const defaultFormatDate = (date, dateFormat = 'yyyy-MM-dd') =>
  date && isValid(date) ? format(date, dateFormat) : '';

export const FORMAT_UTC_OFFSET = "'UTC' x";

export const FORMAT_HOUR_MINUTE = 'HH:mm';

export const getUTCOffset = (timeZone) => format(new Date(), 'x', { timeZone });

export const parseDateWithTimeZone = (utcString, timeZone) =>
  utcToZonedTime(parseISO(utcString), timeZone);

export const formatDateStringWithTimeZone = (dateString, dateFormat, timeZone) =>
  format(utcToZonedTime(parseISO(dateString), timeZone), dateFormat, { timeZone });

export const formatRangeDate = (startDate, endDate, formatDate = formatDayDateMonthYear) => {
  const from = formatDate(startDate);
  const to = formatDate(endDate);
  return `${from}${from ? ' - ' : ''}${to}`;
};
